module.exports = __webpack_public_path__ + "img/en.515b5ce6.jpg";